import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const Title = styled.strong`
  margin-bottom: 0.2rem;
  font-size: 1rem;
  color: var(--bs-primary, #0d6efd);
`;

const TableWrapper = styled.div`
  overflow-x: auto;
`;

const StyledTable = styled.table`
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
`;

const TableBody = styled.tbody`
  font-weight: normal;
`;

/**
 * @typedef {Object} TableColumn
 * @property {string} key - Unique key for the column.
 * @property {string} header - Column header text.
 */

/**
 * @typedef {Object} TableItem
 * @property {string} key - Unique key for the row.
 * @property {React.ReactNode[]} cells - Array of cell content for the row.
 */

/**
 * @typedef {Object} TableData
 * @property {TableColumn[]} columns - Column definitions.
 * @property {TableItem[]} items - Table row data.
 */

/**
 * @param {string} [title] - Optional table title.
 * @param {TableData} tableData - Structured table content.
 */
export const DataTableUI = ({ title, tableData }) => {
  if (!tableData.items.length) return null;

  return (
      <Wrapper>
        {title && <Title>{title}</Title>}
        <TableWrapper>
          <StyledTable className="table table-borderless">
            <thead>
            <tr>
              {tableData.columns.map((col) => (
                  <th key={col.key}>{col.header}</th>
              ))}
            </tr>
            </thead>
            <TableBody>
              {tableData.items.map((item) => (
                  <tr key={item.key}>
                    {item.cells.map((cell, idx) => (
                        <td key={idx}>{cell}</td>
                    ))}
                  </tr>
              ))}
            </TableBody>
          </StyledTable>
        </TableWrapper>
      </Wrapper>
  );
};
